import { render, staticRenderFns } from "./ProductStatus.vue?vue&type=template&id=1a6aa1fa&"
import script from "./ProductStatus.vue?vue&type=script&lang=ts&"
export * from "./ProductStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ProductStatus.vue?vue&type=style&index=0&id=1a6aa1fa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports